












import Vue from 'vue';

export default Vue.extend({
  name: 'NemiFooter',
  data: () => ({
    currentYear: new Date().getFullYear(),
    tenantName: process.env.VUE_APP_TENANT_NAME || 'My Tenant',
    companyHost: process.env.VUE_APP_COMPANY_HOST || 'My Company',
    websiteUrl: process.env.VUE_APP_WEBSITE_URL || 'https://example.com',
  }),
});
